// extracted by mini-css-extract-plugin
export default {"rootClassName":"bullets"};